var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
import { Exclude, Expose, Type } from 'class-transformer';
import { IsArray, IsBoolean, IsDateString, IsNumber, IsOptional, IsString, IsUUID, } from 'class-validator';
import { NotificationFullSizeDto } from '../../notification/index.js';
import { ExerciseProgramItemFullSizeDto } from './exercise-program-item.full-size.dto.js';
export class ExerciseProgramLiteDto {
    id;
    createdAt;
    updatedAt;
    name;
    version;
    startDate = new Date();
    endDate;
    userId;
    exerciseProgramItems = [];
    trainingIsOnMonday;
    trainingIsOnTuesday;
    trainingIsOnWednesday;
    trainingIsOnThursday;
    trainingIsOnFriday;
    trainingIsOnSaturday;
    trainingIsOnSunday;
    diagnosisId;
    diagnosis;
    officeId;
    index;
    notifications;
    userOfficeId;
    officeProductAssignmentId;
}
__decorate([
    IsUUID(),
    Expose(),
    __metadata("design:type", String)
], ExerciseProgramLiteDto.prototype, "id", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], ExerciseProgramLiteDto.prototype, "createdAt", void 0);
__decorate([
    IsDateString(),
    Exclude(),
    __metadata("design:type", Date)
], ExerciseProgramLiteDto.prototype, "updatedAt", void 0);
__decorate([
    IsString(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseProgramLiteDto.prototype, "name", void 0);
__decorate([
    IsNumber(),
    Expose(),
    __metadata("design:type", Number)
], ExerciseProgramLiteDto.prototype, "version", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Date)
], ExerciseProgramLiteDto.prototype, "startDate", void 0);
__decorate([
    IsDateString(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseProgramLiteDto.prototype, "endDate", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseProgramLiteDto.prototype, "userId", void 0);
__decorate([
    IsArray(),
    Type(() => ExerciseProgramItemFullSizeDto),
    Expose(),
    __metadata("design:type", Array)
], ExerciseProgramLiteDto.prototype, "exerciseProgramItems", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], ExerciseProgramLiteDto.prototype, "trainingIsOnMonday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], ExerciseProgramLiteDto.prototype, "trainingIsOnTuesday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], ExerciseProgramLiteDto.prototype, "trainingIsOnWednesday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], ExerciseProgramLiteDto.prototype, "trainingIsOnThursday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], ExerciseProgramLiteDto.prototype, "trainingIsOnFriday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], ExerciseProgramLiteDto.prototype, "trainingIsOnSaturday", void 0);
__decorate([
    IsBoolean(),
    Expose(),
    __metadata("design:type", Boolean)
], ExerciseProgramLiteDto.prototype, "trainingIsOnSunday", void 0);
__decorate([
    IsUUID(),
    Exclude(),
    __metadata("design:type", Object)
], ExerciseProgramLiteDto.prototype, "officeId", void 0);
__decorate([
    Expose(),
    IsNumber(),
    __metadata("design:type", Object)
], ExerciseProgramLiteDto.prototype, "index", void 0);
__decorate([
    IsArray(),
    Type(() => NotificationFullSizeDto),
    Exclude(),
    __metadata("design:type", Array)
], ExerciseProgramLiteDto.prototype, "notifications", void 0);
__decorate([
    IsUUID(),
    Exclude(),
    __metadata("design:type", Object)
], ExerciseProgramLiteDto.prototype, "userOfficeId", void 0);
__decorate([
    IsUUID(),
    IsOptional(),
    Expose(),
    __metadata("design:type", Object)
], ExerciseProgramLiteDto.prototype, "officeProductAssignmentId", void 0);
//# sourceMappingURL=exercise-program.lite.dto.js.map